import { useEffect, useState } from "react";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { WordCountList } from "src/app/types/orders/order";

const useWordCountOptions = () => {
    const [wordCountOptions, setWordCountOptions] = useState<Array<SimpleFormSelectOption>>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const wordCountBuilder: Array<SimpleFormSelectOption> = [];

        WordCountList.forEach((wordCount) => {
            wordCountBuilder.push({
                value: wordCount,
                label: wordCount.toString(),
            });
        });

        setWordCountOptions(wordCountBuilder);
        setLoading(false);
    }, []);

    return { wordCountOptions, loading };
};

export default useWordCountOptions;
